// staffs/vm-teacher
import { useListIds } from 'src/hooks/use-list-table';
import { useListSearch } from 'src/hooks/use-list-search';
import { useItemsStore } from 'src/hooks/use-items-store';
import { startLoading, stopLoading } from 'src/utils/loading';
import { getMyList, getMyItem, apiUpdate, apiRemove } from './data';

export const useItemsSearch = () => {
  return useListSearch();
};
export const useItemsIds = () => {
  return useListIds();
};

class TeacherStaffApi {
  getItems(searchState) {
    return useItemsStore(searchState, getMyList);
  }

  getDetail(payload, onSuccess) {
    getMyItem(payload).then((result) => {
      onSuccess(result);
    });
  }
}
export const teacherStaffApi = new TeacherStaffApi();

class TeacherStaffForm {
  updateItem = async (payload, onSuccess, onError) => {
    startLoading();
    //payload.fuelId = payload.myId; // Add new fuelId
    const { myId, ...newPayload } = payload; // Remove myId
    const {result, error} = await apiUpdate(newPayload);
    stopLoading();

    if(result){
      onSuccess(`${result}`);
    }else{
      onError(error);
    }
  };

  removeItem = async (payload, onSuccess, onError) => {
    startLoading();
    const {result, error} = await apiRemove(payload);
    stopLoading();
    
    if(result){
      onSuccess(`${result}`);
    }else{
      onError(error);
    }
  };
}
export const teacherStaffForm = new TeacherStaffForm();
